import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import Global from '../../../store/global-selectors';
import { calculatePagingStats, allowablePageSizes, PAGE_SIZE_250, FIRST_PAGE } from '../../../services/pagination-service';
import { PagingControl } from '../../../components/paging-control';

import { usePaging } from '../../../hooks/use-paging';
import { getBatchDetails } from '../../../store/batches/details/batch.details.actions';

export const BatchDetailGridPagingControl = () => {
  const dispatch = useDispatch();
  const { page, pageSize, updatePageInformation } = usePaging();
  const orderNumberSelected = useSelector(Global.selectSelectedOrdersCount);
  const orderGridTotalRecords = useSelector(Global.selectOrdersGridTotalRecords);
  const pagingStats = calculatePagingStats(page, pageSize, orderGridTotalRecords);
  const { batchId } = useParams();

  const handlePageChange = useCallback(
    (_page, _pageSize) => {
      const updatedPage = pagingStats.totalRecords < _pageSize ? 1 : _page;
      updatePageInformation(updatedPage, _pageSize);
      dispatch(getBatchDetails(batchId));
    },
    [updatePageInformation, dispatch, pagingStats.totalRecords, batchId],
  );

  useEffect(() => {
    const shouldSanitizePageData = (pagingStats.totalPages > 0 && page > pagingStats.totalPages) || !allowablePageSizes.includes(pageSize);
    if (shouldSanitizePageData) {
      const correctedPage = page > pagingStats.totalPages ? FIRST_PAGE : page;
      const correctedPageSize = allowablePageSizes.includes(pageSize) ? pageSize : PAGE_SIZE_250;
      handlePageChange(correctedPage, correctedPageSize);
    }
  }, [page, pageSize, handlePageChange, pagingStats.totalPages]);

  return <PagingControl {...pagingStats} numberSelected={orderNumberSelected} onPageChange={handlePageChange} />;
};
